import { create } from "zustand";
import { InterfaceChaseItem } from "../types/chase-item-types";
import { DriverInterface } from "../types/driver-type";
import { TimelineInterface } from "../types/chase-timeline-types";

export interface DriverResponseInterface extends DriverInterface {
    chaseItem: InterfaceChaseItem[]
}

interface IdefaultValues {
    id: number | string,
    chaseItems: InterfaceChaseItem[],
    drivers: DriverResponseInterface[]
    timeline: TimelineInterface[]
    data?: Record<string, any>
}

const defaultValues = {
    id: "",
    chaseItems: [],
    drivers: [],
    timeline: [],
    data: {}
}

interface IuseChaseMenu {
    onChaseMenuOpen: ({ id, chaseItems, drivers }: IdefaultValues) => void,
    onChaseMenuClose: () => void
    onToggleChaseMenu: ({ id, chaseItems, drivers }: IdefaultValues) => void
    initialValues: IdefaultValues
}

export const useChaseMenu = create<IuseChaseMenu>((set) => ({
    initialValues: defaultValues,
    onChaseMenuOpen: ({ id, chaseItems, drivers, data, timeline }: IdefaultValues) => set({
        initialValues: { id, chaseItems, drivers, data, timeline }
    }),
    onChaseMenuClose: () => set({
        initialValues: defaultValues
    }),
    onToggleChaseMenu: ({ id, chaseItems, drivers, data, timeline }: IdefaultValues) => set((prevState) => ({
        initialValues: prevState.initialValues.id === id ? defaultValues : { id, chaseItems, drivers, data, timeline }
    })),
}))
